import { render, staticRenderFns } from "./ReadyChip.vue?vue&type=template&id=02edcfa5&scoped=true&"
import script from "./ReadyChip.vue?vue&type=script&lang=js&"
export * from "./ReadyChip.vue?vue&type=script&lang=js&"
import style0 from "./ReadyChip.vue?vue&type=style&index=0&id=02edcfa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02edcfa5",
  null
  
)

export default component.exports